import { Card, Empty } from 'antd';
export default function DeploymentPage() {
  return <Card style={{marginTop:16}} title="部署管理"><Empty description="请在AI全流程中完成部署" /></Card>;
}
